//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import TaskActionButton from '../Task/TaskActionButton.vue'

export default {
  components: {
    TaskActionButton
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    displayResumeRequestMgt: function () {
      const resumeInfo = this.request.supTaskData && this.request.supTaskData.resumeInfo || null
      return !!(this.request.id && resumeInfo && (resumeInfo.cancelled || resumeInfo.closed) && this.$d_hasRole('admin', 'dispatcher'))
    },
    disableResumeRequestMgt: function () {
      return this.displayResumeRequestMgt && !this.request.supTaskData.resumeInfo.resumeAvailable
    },
    disableResumeRequestMgtMessage: function () {
      if (this.disableResumeRequestMgt) {
        return this.getRequestMgtResumeUnavailableMessage(this.request.supTaskData.resumeInfo)
      }
      return null
    }
  },
  methods: {
    onResumeRequestMgt: function (event, navigateFn, loadingActivity) {
      const supTaskVersions = this.request.supTaskData.supTask
      const supTask = supTaskVersions && supTaskVersions.length && supTaskVersions[supTaskVersions.length - 1] || {}
      const actionName = 'Возобновление задачи ПТК АПТС'

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            loadingActivity && loadingActivity.startLoading(actionName)
            this.resumeRequestMgt()
              .finally(() => {
                loadingActivity && loadingActivity.stopLoading()
              })
          }
        },
        header: actionName,
        propsConfig: {
          number: { type: 'text', label: 'Номер задачи ПТК АПТС', value: supTask.number, readonly: true },
          address: { type: 'text', label: 'Адрес', value: supTask.address, readonly: true }
        },
        buttons: [
          { key: 'yes', name: 'Подтвердить' },
          { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
        ]
      })
    },
    getRequestMgtResumeUnavailableMessage: function (resumeInfo) {
      let message
      if (!(resumeInfo.cancelled || resumeInfo.closed)) {
        message = 'Задача ПТК АПТС уже возобновлена'
      } else if (!resumeInfo.matchBPState) {
        message = 'Статус заявки «' + this.request.bpStateName + '» не удовлетворяет условиям отмены задачи ПТК АПТС'
      } else if (!resumeInfo.matchSupStatus) {
        message = 'Текущий статус задачи: ' + resumeInfo.statusName
        if (resumeInfo.statusTimeoutExceeded) {
          message = message + '. Истек разрешенный срок изменений (30 дней)'
        } else {
          message = message + '. Статус не удовлетворяет условиям возобновления'
        }
      }
      if (message == null) {
        message = 'Задача ПТК АПТС не может быть возобновлена'
      }
      return message
    },
    resumeRequestMgt: function () {
      const params = new URLSearchParams()
      params.append('id', this.request.id)

      return axiosGet({
        url: '/service/delta/request/resumeSupTask?' + params.toString(),
        onSuccess: (response) => {
          const supTaskData = response.data.result
          this.request.supTaskData = supTaskData

          this.$q.notify({
            type: 'positive',
            message: response.data && response.data.message || 'Задача ПТК АПТС возобновлена',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          let message
          let caption
          if (response.code === 'timeout') {
            message = 'Истек таймаут запроса возобновления задачи ПТК АПТС'
            caption = 'Повторите операцию, при повторной ошибке обратитесь к администратору.'
          } else {
            message = 'Ошибка возобновления задачи ПТК АПТС'
            const result = response.result
            if (result && result.resumeInfo && result.resumeInfo.resumeAvailable === false) {
              this.request.supTaskData = result

              caption = this.getRequestMgtResumeUnavailableMessage(result)
            } else {
              caption = response && response.message || null
            }
          }

          this.$q.notify({
            type: 'negative',
            message: message,
            caption: caption,
            timeout: 8000,
            progress: true
          })
        }
      })
    }
  }
}

